module.exports = __webpack_public_path__ + "assets/7b59ad2a0860bcb43ee323210f631653.mp3";